module.exports = __webpack_public_path__ + "static/img/11.faf273d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/11.png
// module id = De4H
// module chunks = 0